import React, { useEffect } from "react";
//

// fade animation related AOS
import Aos from "aos";
import "aos/dist/aos.css";
//
// zoom in related
import { motion } from "framer-motion";
//<motion.  add this to any img you want to scale
// data-aos-duration="1000" ,adding this will make the anim go faster therefore the performance will be a bit better
//
//

const FurnitureModal = ({ selectedImgFurniture, setSelectedImgFurniture }) => {
  const handleClickFurniture = (e) => {
    if (e.target.classList.contains("backdropFurniture")) {
      setSelectedImgFurniture(null);
    }
  };
  //
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  //
  //
  return (
    <div className="backdropFurniture" onClick={handleClickFurniture}>
      <motion.img
        onClick={(e) => e.stopPropagation()}
        data-aos="fade"
        onHoverStart={(eImg) => {}}
        onHoverEnd={(eImg) => {}}
        src={selectedImgFurniture}
        alt="enlarged pic"
      />
    </div>
  );
};

export default FurnitureModal;
